import { gql } from '@apollo/client'

const SUBMIT_INSURANCE_CARD = gql`
  mutation submitInsuranceCard(
    $insurancePolicyStateId: ID!
    $frontPhoto: Upload!
    $backPhoto: Upload!
  ) {
    submitInsuranceCard(
      insurancePolicyStateId: $insurancePolicyStateId
      frontPhoto: $frontPhoto
      backPhoto: $backPhoto
    ) {
      id
    }
  }
`

export default SUBMIT_INSURANCE_CARD
